import * as React from 'react';
import { connect } from 'react-redux';
import { find, get } from 'lodash';
import { Link } from 'react-router-dom';
import { logUI } from '../../api/andyliticsApi';
import { Redirect } from 'react-router-dom';
import * as Tools from '../../helpers/Tools';
import * as types from '../../constants/actionTypes';
import FooterLoggedOut from '../common/footer/FooterLoggedOut';
import GenericInput from '../common/input/GenericInput';
import LoginCards from './LoginCards';
import LoginCarousel from './LoginCarousel';
import Spinner from '../common/spinner';
import StaticHtmlContent from '../common/staticHtmlContent';

import { withTranslation } from 'react-i18next';

const browserName = Tools.browserDetection();
const chromeWebUrl = 'https://www.google.com/chrome/';
const duplicateError = 'possible duplicate user';
const edgeWebUrl = 'https://www.microsoft.com/en-us/edge';
const fcDuplicateUserError = 'fc duplicate user found';
const isChromeBrowser = browserName === 'Chrome';
const isEdgeBrowser = browserName === 'Edge';
const isIEBrowser = browserName === 'IE';
const isIos = Tools.isIos();
const isSafariBrowser = browserName === 'Safari';
const lockedUserError = 'user_is_locked';

/**
 * Container component for the Login page.
 *
 */
class Login extends React.Component {
  constructor(props) {
    super(props);
    const dBust = new Date();

    const { reDirectURL } = props; //checking redirecturl if it has directed with rx/acceptproxy and append it to registration url.
    let mapProxyRequesteeInfo = '';
    if (reDirectURL) {
      if (reDirectURL.includes('/rx/acceptproxy')) {
        mapProxyRequesteeInfo = 'rx-request';
      } else if (reDirectURL.includes('/proxygrant/accept')) {
        mapProxyRequesteeInfo = reDirectURL.includes('/rx/')
          ? 'rx-grant'
          : 'epic-grant';
      }
    }
    const pathname =
      mapProxyRequesteeInfo &&
      `?mapproxyrequesteeinfo=${mapProxyRequesteeInfo}&bswhroute=${reDirectURL}`;

    this.state = {
      fields: {
        username: '',
        password: '',
      },
      errors: {},
      userLoggedInOnLoad: false,
      loadBye: true,
      capsLock: false,
      showCapsLockWrn: false,
      bustKey: dBust.getTime(),
      pathname,
    };

    if (this.props && this.props.errorCode === 401) {
      //rendering happening twice so handle it in state.
      let fields = this.state.fields;
      let errors = this.state.errors;
      errors['errorCode'] = this.props.errorCode;
      this.state = { fields: fields, errors: errors };
    }
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleUserNameChange = this.handleChange.bind(this, 'username');
    this.handlePasswordChange = this.handleChange.bind(this, 'password');
    this.setupMesssageClearTimer = this.setupMesssageClearTimer.bind(this);
    this.clearMessage = this.clearMessage.bind(this);
    this.handleKeyDownEvent = this.handleKeyDownEvent.bind(this);
    this.handleKeyUpEvent = this.handleKeyUpEvent.bind(this);
    this.isMobile = Tools.isMobile();
    this.getSanitizeError = this.getSanitizeError.bind(this);
    this.InCompatiblebrowserVersions = JSON.parse(
      this.props.myBSWHealthIncompatibleBrowserVersion.unescapeHTML()
    );
  }

  componentWillMount() {
    this.setupMesssageClearTimer();
  }

  componentDidMount() {
    if (!this.props.reDirectURL) {
      this.props.setRedirectUrl('/');
    }
    if (this.props.isLoggedIn && !this.state.userLoggedInOnLoad) {
      this.setState({ userLoggedInOnLoad: true });
    }
    const dBust = new Date();
    this.setState({ bustKey: dBust.getTime(), loadBye: true });
    logUI('MBHWeb.UI.Login.ComponentDidMount', new Date(), Tools.getURLPath());
    if (document) {
      document.addEventListener('keydown', this.handleKeyDownEvent, false);
      document.addEventListener('keyup', this.handleKeyUpEvent, false);
      if (document.msCapsLockWarningOff === false)
        document.msCapsLockWarningOff = true;
    }
  }

  componentDidUpdate() {
    this.setupMesssageClearTimer();
  }

  componentWillUnmount() {
    if (document) {
      document.removeEventListener('keydown', this.handleKeyDownEvent, false);
      document.removeEventListener('keyup', this.handleKeyUpEvent, false);
    }
  }

  timerHandle = null;

  clearMessage() {
    this.props.clearLogoutMessage();
  }

  setupMesssageClearTimer() {
    if (this.timerHandle === null && typeof window !== 'undefined') {
      this.timerHandle = window.setTimeout(this.clearMessage, 15000);
    }
  }

  setField(field, e) {
    let fields = this.state.fields;
    fields[field] = e;
    this.setState({ fields });
  }

  handleSubmit(event) {
    event.preventDefault();
    let validationErrors = this.state.errors;
    validationErrors['errorCode'] = '';
    this.setState({ errors: validationErrors, loadBye: false });
    if (this.handleValidation()) {
      this.setField('submitted', true);
      // We have to hack it like this to trigger IE to save the password.
      try {
        document
          .getElementById('LoginShim')
          .contentDocument.getElementById(
            'username'
          ).value = this.state.fields.username;
        document
          .getElementById('LoginShim')
          .contentDocument.getElementById(
            'password'
          ).value = this.state.fields.password;
        document
          .getElementById('LoginShim')
          .contentDocument.getElementById('loginShim')
          .submit();
      } catch (EE) {
        console.error(EE);
      }

      this.props.onLoginClick(
        this.state.fields.username,
        this.state.fields.password
      );
      logUI('MBHWeb.Logon.Client.Post', new Date(), Tools.getURLPath());
      return true;
    } else {
      event.preventDefault();
      return false;
    }
  }

  handleChange(field, e) {
    let fields = this.state.fields;
    fields[field] = e.target.value;
    fields['submitted'] = false;
    this.setState({ fields });
    this.handleValidation();
  }

  handleValidation() {
    let fields = this.state.fields;
    let validationErrors = {};
    if (this.state.errors['errorCode'] === 401) {
      validationErrors['errorCode'] = '401';
    }
    let formIsValid = true;
    const errorUserName = '';
    const errorPassword = '';
    if (fields === undefined) {
      formIsValid = false;
      this.setState({ fields: { username: '', password: '' } });
      validationErrors['username'] = errorUserName;
      validationErrors['password'] = errorPassword;
    } else {
      //username
      if (!fields['username']) {
        formIsValid = false;
        validationErrors['username'] = errorUserName;
      }
      //password
      if (!fields['password']) {
        formIsValid = false;
        validationErrors['password'] = errorPassword;
      }
    }

    this.setState({ errors: validationErrors });
    return formIsValid;
  }

  handleKeyDownEvent(keyEvent) {
    this.handleCapsLockEvent(keyEvent);
  }

  //Added for support Mac
  handleKeyUpEvent(keyEvent) {
    this.handleCapsLockEvent(keyEvent);
  }

  handleCapsLockEvent(keyEvent) {
    const { capsLock } = this.state;
    if (
      keyEvent.getModifierState &&
      keyEvent.getModifierState('CapsLock') !== capsLock
    ) {
      this.setState({ capsLock: keyEvent.getModifierState('CapsLock') });
    }
  }

  getSanitizeError(errorLogin) {
    if (errorLogin) {
      if (errorLogin.toLowerCase() === duplicateError) {
        logUI(
          'MBHWeb.Logon.Client.Duplicate.MYBSWHFC',
          new Date(),
          Tools.getURLPath()
        );
        const content = `Your login credentials need to be reconciled by the MyBSWHealth technical help desk. Call <a class="phone-link" href='${'tel:' +
          this.props.technicalHelpDeskNumber}'>${
          this.props.technicalHelpDeskNumber
        }</a> ${this.props.technicalHelpDeskHours}.`;
        return (
          <span
            dangerouslySetInnerHTML={{
              __html: content,
            }}
          />
        );
      } else if (errorLogin.toLowerCase() === fcDuplicateUserError) {
        logUI(
          'MBHWeb.Logon.Client.Duplicate.FC',
          new Date(),
          Tools.getURLPath()
        );
        const registrationUrl =
          this.props.myChartRegistrationUrl + 'verification/sms?option=No';
        const content = `Your legacy MyFirstCare Self-Service username was claimed by an existing MyBSWHealth portal user. Please click <a href='${registrationUrl}'>here</a> to go through the registration process to set up your account with a new username and password.`;
        return (
          <span>
            <StaticHtmlContent content={content} />{' '}
          </span>
        );
      }
    }

    return errorLogin;
  }

  render() {
    const isClientSide = typeof window !== 'undefined';

    const {
      EnableLoginScreenV2,
      errorLogin,
      isLoggingIn,
      loginErrorCode,
      loginNotice,
      reDirectParams,
      reDirectURL,
      serviceError,
      userErrorMsg,
      verifiedLogin,
    } = this.props;
    const isUserLoggedin = this.props.isLoggedIn;
    const serviceWaitings =
      this.props.waiting === false || this.props.waiting === undefined
        ? false
        : true;
    const createAccountLink =
      this.props.myChartRegistrationUrl + this.state.pathname;
    const { isLoggedIn, myChartByeUrl,t } = this.props;
    const { loadBye, bustKey, capsLock, showCapsLockWrn } = this.state;
    const bustedURL = myChartByeUrl + bustKey;

    const { userLoggedInOnLoad } = this.state;

    const slides = [
     
      {
        id: 0,
        body: 'View lab results and past visit summaries',
        heading: 'Test results',
        img: 'images/image-web-test-results.png',
      },
      {
        id: 1,
        body: 'Talk to a doc from anywhere',
        heading: 'Video visits',
        img: 'images/image-web-video-visits.png',
      },
      {
        id: 2,
        body: "Manage the family's healthcare needs from one place",
        heading: "My family's health",
        img: 'images/image-web-family-management.png',
      },
      {
        id: 3,
        body: 'Make appointments on your schedule',
        heading: 'Scheduling',
        img: 'images/image-web-scheduling.png',
      },
      {
        id: 4,
        body: 'Securely communicate with your care team',
        heading: 'Messaging my doc',
        img: 'images/image-web-messaging.png',
      },
      
    ];

    const cards = [
      
      {
        id: 0,
        body: 'View lab results and past visit summaries',
        heading: 'Test results',
        img: 'images/test-results.png',
      },
      {
        id: 1,
        body: 'Talk to a doc from anywhere',
        heading: 'Video visits',
        img: 'images/video-visits.png',
      },
      {
        id: 2,
        body: "Manage the family's healthcare needs from one place",
        heading: "My family's health",
        img: 'images/family-management.png',
      },
      {
        id: 3,
        body: 'Make appointments on your schedule',
        heading: 'Scheduling',
        img: 'images/scheduling.png',
      },
      {
        id: 4,
        body: 'Securely communicate with your care team',
        heading: 'Messaging my doc',
        img: 'images/messaging.png',
      },
      
    ];

    // Should not be solving this problem here
    if (userLoggedInOnLoad) {
      if (isClientSide && window.location.pathname !== reDirectURL) {
        //debugger;
        return (
          <Redirect
            push
            to={
              reDirectParams ? reDirectURL + reDirectParams : reDirectURL || '/'
            }
          />
        );
      }
    }

    const InCompatibleBrowserVersion = get(
      find(this.InCompatiblebrowserVersions, browserName),
      browserName
    );

    const showoutDatedMessage =
      isIEBrowser ||
      isEdgeBrowser ||
      (typeof InCompatibleBrowserVersion !== undefined &&
        Number(Tools.getBroswerVersion()) < InCompatibleBrowserVersion);

    return (
      <>
        {EnableLoginScreenV2 ? (
          <>
            {loginErrorCode === lockedUserError && (
              <div className="user-login-locked-message-container">
                <span className="icon-important" />
                <StaticHtmlContent
                  classname="user-locked-msg"
                  content={userErrorMsg}
                />
              </div>
            )}

            {showoutDatedMessage && (
              <div className="browser-outdated-message-container_v2">
                <span className="icon-important" />
                Your browser is outdated and may cause features not to work
                properly in MyBSWHealth. For the best performance&nbsp;
                {isIos ? (
                  isSafariBrowser ? (
                    'update Safari'
                  ) : (
                    'use Safari'
                  )
                ) : (
                  <>
                    {!isEdgeBrowser && !isChromeBrowser && <>use </>}
                    {
                      <a
                        href={
                          isIEBrowser || isEdgeBrowser
                            ? edgeWebUrl
                            : chromeWebUrl
                        }
                        target="_blank"
                      >
                        {isIEBrowser
                          ? 'Edge'
                          : isEdgeBrowser
                          ? 'update Edge'
                          : isChromeBrowser
                          ? 'update Chrome'
                          : 'Chrome'}
                      </a>
                    }
                  </>
                )}
                .
              </div>
            )}
            {window.serverData.data.enableI18N_LanguageSelection&&(
              <div><a onClick={()=>{
                this.props.i18n.changeLanguage('en');
              }}>en</a> | <a onClick={()=>{
                this.props.i18n.changeLanguage('es');
              }}>es</a></div>
            )}
            <div className="login-container_v2" role="main">
              <div className="login-header">
                            <img onClick={event => { if (event.ctrlKey && window.serverData.data.environment !== "PROD") { window.alert(`Currently running build from the (${document.querySelector("body").getAttribute("data-version")}) branch. If null then view source and check the bottom of the body element to see version`); } }}
                  alt="Baylor Scott & White Health logo"
                  className="header-logo"
                  src="/images/mybswlogo.svg"
                />

                <div className="link-wrapper">
                  <Link className="link" to={{ pathname: '/payasguest' }}>
                    <span aria-hidden="true" className="icon-credit-card" />
                                    {t("Pay a bill as a guest")}
                  </Link>
                  <Link
                    className="link"
                    to={{
                      hash: '#family member (proxy) management',
                      pathname: '/faq',
                    }}
                  >
                    <span aria-hidden="true" className="icon-family" />
                                    {t("How to access family health")}
                  </Link>
                </div>
              </div>
              <div className="container-fluid login-form-container maxWidth-content">
                <div className="row">
                  {!serviceWaitings ? (
                    <>
                      <div className="col-12 col-md-8 login-slider">
                        <LoginCarousel slides={slides} />
                      </div>

                      <div className="col-12 col-md-4 page-form-smb">
                        <div className="row ">
                          <div className="col-12 login-text">
                            {t("Sign in to MyBSWHealth")}
                          </div>
                        </div>

                        {typeof loginNotice !== 'undefined' && loginNotice && (
                          <div className="col-12">
                            <div className="row login-notice">
                              <div className="col-1 icon">
                                <span className="icon-error" />
                              </div>
                              <div className="col-11">
                                <p
                                  dangerouslySetInnerHTML={{
                                    __html: Tools.linkPhoneNumber(loginNotice),
                                  }}
                                />
                              </div>
                            </div>
                          </div>
                        )}
                        <form
                          className="row login-form"
                          onSubmit={this.handleSubmit}
                        >
                          {(errorLogin ||
                            serviceError ||
                            this.state.errors['errorCode'] === 401) &&
                          loginErrorCode !== lockedUserError ? (
                            <div className="col-12 form-errors">
                              {(errorLogin || serviceError) && (
                                <div>
                                  {this.getSanitizeError(errorLogin) ||
                                    t('Login failed. Please try again later.')}
                                </div>
                              )}
                              {this.state.errors['errorCode'] === 401 && (
                                <div>
                                                                    {t("Your token has expired. Please sign in again.")}
                                </div>
                              )}
                            </div>
                          ) : (
                            ''
                          )}
                          {this.props.logoutMessage && (
                            <div
                              className={
                                'col-12' +
                                (this.props.logoutMessage ===
                                'You have been logged out successfully.'
                                  ? ' logout-msg'
                                  : ' form-errors')
                              }
                            >
                              <div>{this.props.logoutMessage}</div>
                            </div>
                          )}
                          <div className="col-12 form-group">
                            <GenericInput
                              autoFocus
                              inputErrorMsg={this.state.errors['username']}
                              name="username"
                              onChange={e => this.handleUserNameChange(e)}
                              placeholder="Username"
                              ref="username"
                              required
                              showClearBtn
                              value={this.state.fields['username']}
                            />
                          </div>
                          <div className="col-12 form-group">
                            <GenericInput
                              inputErrorMsg={this.state.errors['password']}
                              name="password"
                              onBlur={() => {
                                if (showCapsLockWrn)
                                  this.setState({ showCapsLockWrn: false });
                              }}
                              onChange={e => this.handlePasswordChange(e)}
                              onFocus={() => {
                                if (!showCapsLockWrn)
                                  this.setState({ showCapsLockWrn: true });
                              }}
                              onKeyUp={() => {
                                if (!showCapsLockWrn)
                                  this.setState({ showCapsLockWrn: true });
                              }}
                              placeholder="Password"
                              ref="password"
                              required
                              showClearBtn
                              showEye
                              type="password"
                              value={this.state.fields['password']}
                            />
                            {capsLock && showCapsLockWrn && (
                                                        <div className="hint-text">{t("Caps lock is on.")}</div>
                            )}
                          </div>
                          <div className="col-12 form-group">
                            <input
                              className="btn btn-primary"
                              type="submit"
                              value="Sign In"
                              disabled={!isClientSide}
                            />
                            <div className="row login-footer">
                              <div className="col-12">
                                <div className="sign-up">
                                  <div>{t("New to MyBSWHealth?")}</div>
                                  <a
                                    className="create-account"
                                    href={createAccountLink}
                                    onClick={() =>
                                      logUI(
                                        'MBHWeb.UI.Logon.CreateAccount.Clicked',
                                        new Date(),
                                        Tools.getURLPath()
                                      )
                                    }
                                  >
                                                                    {t("CREATE ACCOUNT")}
                                  </a>
                                </div>

                                {isClientSide && (
                                  <div className="forgot-links">
                                    <Link
                                      className="forgot-link"
                                      onClick={() =>
                                        logUI(
                                          'MBHWeb.UI.Logon.ForgotUserNameClicked',
                                          new Date(),
                                          Tools.getURLPath()
                                        )
                                      }
                                      to="/forgotusername"
                                    >
                                      {t("FORGOT USERNAME")}
                                    </Link>
                                    <Link
                                      className="forgot-link"
                                      onClick={() =>
                                        logUI(
                                          'MBHWeb.UI.Logon.ForgotPasswordClicked',
                                          new Date(),
                                          Tools.getURLPath()
                                        )
                                      }
                                      to="/forgotpassword"
                                    >
                                        {t("FORGOT PASSWORD")}
                                    </Link>
                                  </div>
                                )}
                              </div>
                            </div>
                          </div>
                        </form>
                      </div>
                    </>
                  ) : (
                    <Spinner />
                  )}
                </div>
              </div>
              {/* end of login-form-container */}
              <LoginCards cards={cards} />
              <FooterLoggedOut wideFooter />
              {loadBye &&
                verifiedLogin === true &&
                !isUserLoggedin &&
                !isLoggingIn &&
                (window.data && window.data.serverdata && !window.data.serverData.debuggerAttached) && (
                  <iframe
                    aria-hidden="true"
                    src={bustedURL}
                    style={{ display: 'none' }}
                    title="loadBye"
                  />
                )}
            </div>
          </>
        ) : (
          <>
            {loginErrorCode === lockedUserError && (
              <div className="user-login-locked-message-container">
                <span className="icon-important" />
                <StaticHtmlContent
                  classname="user-locked-msg"
                  content={userErrorMsg}
                />
              </div>
            )}

            <div className="login-container" role="main">
              <div className="gradient-bg" />
              {showoutDatedMessage && (
                <div className="browser-outdated-message-container">
                  <span className="icon-important" />
                  Your browser is outdated and may cause features not to work
                  properly in MyBSWHealth. For the best performance&nbsp;
                  {isIos ? (
                    isSafariBrowser ? (
                      'update Safari'
                    ) : (
                      'use Safari'
                    )
                  ) : (
                    <>
                      {!isEdgeBrowser && !isChromeBrowser && <>use </>}
                      {
                        <a
                          href={
                            isIEBrowser || isEdgeBrowser
                              ? edgeWebUrl
                              : chromeWebUrl
                          }
                          target="_blank"
                        >
                          {isIEBrowser
                            ? 'Edge'
                            : isEdgeBrowser
                            ? 'update Edge'
                            : isChromeBrowser
                            ? 'update Chrome'
                            : 'Chrome'}
                        </a>
                      }
                    </>
                  )}
                  .
                </div>
              )}
              <div className="container-fluid login-form-container">
                <div className="row">
                  {!serviceWaitings ? (
                    <>
                      <div className="col-12 page-form-sm">
                        <div className="row login-logo">
                          <div className="col-12">
                            <img
                              src="/images/mybswlogo-white.svg"
                              className="img-fluid"
                              alt="Baylor Scott & White Health logo"
                            />
                            <h1>{t("Sign in to MyBSWHealth")}</h1>
                          </div>
                        </div>
                        {typeof loginNotice !== 'undefined' && loginNotice && (
                          <div className="col-12">
                            <div className="row login-notice">
                              <div className="col-1 icon">
                                <span className="icon-error" />
                              </div>
                              <div className="col-11">
                                <p
                                  dangerouslySetInnerHTML={{
                                    __html: Tools.linkPhoneNumber(loginNotice),
                                  }}
                                />
                              </div>
                            </div>
                          </div>
                        )}
                        <form
                          className="row login-form"
                          onSubmit={this.handleSubmit}
                        >
                          {(errorLogin ||
                            serviceError ||
                            this.state.errors['errorCode'] === 401) &&
                          loginErrorCode !== lockedUserError ? (
                            <div className="col-12 form-errors">
                              {(errorLogin || serviceError) && (
                                <div>
                                    {this.getSanitizeError(errorLogin) ||
                                        t('Login failed. Please try again later.')}
                                </div>
                              )}
                              {this.state.errors['errorCode'] === 401 && (
                                <div>
                                  {t("Your token has expired. Please sign in again.")}
                                </div>
                              )}
                            </div>
                          ) : (
                            ''
                          )}
                          {this.props.logoutMessage && (
                            <div
                              className={
                                'col-12' +
                                (this.props.logoutMessage ===
                                t('You have been logged out successfully.')
                                  ? ' logout-msg'
                                  : ' form-errors')
                              }
                            >
                              <div>{this.props.logoutMessage}</div>
                            </div>
                          )}
                          <div className="col-12 form-group">
                            <GenericInput
                              placeholder={t("Username")}
                              autoFocus
                              value={this.state.fields['username']}
                              name="username"
                              onChange={e => this.handleUserNameChange(e)}
                              required
                              ref="username"
                              inputErrorMsg={this.state.errors['username']}
                              showClearBtn
                            />
                          </div>
                          <div className="col-12 form-group">
                            <GenericInput
                              placeholder={t("Password")}
                              type="password"
                              value={this.state.fields['password']}
                              name="password"
                              ref="password"
                              onChange={e => this.handlePasswordChange(e)}
                              required
                              inputErrorMsg={this.state.errors['password']}
                              onFocus={() => {
                                if (!showCapsLockWrn)
                                  this.setState({ showCapsLockWrn: true });
                              }}
                              onKeyUp={() => {
                                if (!showCapsLockWrn)
                                  this.setState({ showCapsLockWrn: true });
                              }}
                              onBlur={() => {
                                if (showCapsLockWrn)
                                  this.setState({ showCapsLockWrn: false });
                              }}
                              showClearBtn
                              showEye
                            />
                            {capsLock && showCapsLockWrn && (
                                                            <div className="hint-text">{t("Caps lock is on.")}</div>
                            )}
                          </div>
                          <div className="col-12 form-group">
                            <input
                              className="btn btn-primary"
                              type="submit"
                              value={t("Sign In")}
                              disabled={!isClientSide}
                            />
                          </div>
                        </form>
                      </div>
                      <div className="col-12">
                        <div className="row login-footer">
                          <div className="col-12 login-footer__sign-up">
                            <p>
                               {t("Don't have an account?")}{' '}
                              <a
                                href={createAccountLink}
                                onClick={() =>
                                  logUI(
                                    'MBHWeb.UI.Logon.CreateAccount.Clicked',
                                    new Date(),
                                    Tools.getURLPath()
                                  )
                                }
                              >
                              {t("Sign up")}
                              </a>
                            </p>
                            {isClientSide && (
                              <p className="login-footer__forgot-credentials">
                                                                {t("Forgot")}{' '}
                                <Link
                                  to="/forgotusername"
                                  onClick={() =>
                                    logUI(
                                      'MBHWeb.UI.Logon.ForgotUserNameClicked',
                                      new Date(),
                                      Tools.getURLPath()
                                    )
                                  }
                                >
                                                                    {t("username")}
                                </Link>{' '}
                                                                {t("or")}{' '}
                                <Link
                                  to="/forgotpassword"
                                  onClick={() =>
                                    logUI(
                                      'MBHWeb.UI.Logon.ForgotPasswordClicked',
                                      new Date(),
                                      Tools.getURLPath()
                                    )
                                  }
                                >
                                                                    {t("password")}
                                </Link>
                              </p>
                            )}
                            <p className="login-footer__links">
                              <Link to={{ pathname: '/payasguest' }}>
                                <span
                                  aria-hidden="true"
                                  className="icon-credit-card"
                                />
                                                                {t("Pay a bill as a guest")}
                              </Link>
                              <Link
                                to={{
                                  pathname: '/faq',
                                  hash: '#family member (proxy) management',
                                }}
                              >
                                <span
                                  aria-hidden="true"
                                  className="icon-family"
                                />
                                                                {t("How to access family health")}
                              </Link>
                            </p>
                          </div>
                        </div>
                      </div>
                    </>
                  ) : (
                    <Spinner />
                  )}
                </div>
              </div>
              <FooterLoggedOut />

              {loadBye &&
                verifiedLogin === true &&
                !isUserLoggedin &&
                !isLoggingIn && (
                  <iframe
                    title="loadBye"
                    style={{ display: 'none' }}
                    src={bustedURL}
                    aria-hidden="true"
                  />
                )}
            </div>
          </>
        )}
      </>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  return {
    EnableLoginScreenV2:
      state.session.serverData && state.session.serverData.EnableLoginScreenV2,
    userDetails: state.sso.userDetails,
    isError: state.sso.error,
    errorLogin: state.sso.loginError,
    loginErrorCode: state.sso.errorCode,
    userErrorMsg: state.sso.userErrorMessage,
    waiting: state.sso.isFetching,
    reDirectURL: window.redirectURL,
    reDirectParams: state.domain.qp,
    errorCode: state.header.error || state.dashboard.error,
    myChartRegistrationUrl: state.session.serverData
      ? state.session.serverData.myChartRegistrationUrl
      : '',
    logoutMessage: state.domain.lom || null,
    isLoggedIn: state.domain.li || false,
    myChartByeUrl: state.session.serverData
      ? state.session.serverData.myChartByeUrl
      : '',
    verifiedLogin: state.sso.verifiedLogin,
    loginNotice: state.session.serverData
      ? state.session.serverData.loginNotice
      : '',
    technicalHelpDeskNumber: state.session.serverData
      ? state.session.serverData.technicalHelpDeskNumber
      : '',
    technicalHelpDeskHours: state.session.serverData
      ? state.session.serverData.technicalHelpDeskHours
      : '',
    isLoggingIn: state.sso.isLoggingIn,
    myBSWHealthIncompatibleBrowserVersion: state.session.serverData
      ? state.session.serverData.myBSWHealthIncompatibleBrowserVersion
      : '',
  };
};

const mapDispatchToProps = dispatch => {
  return {
    onLoginClick: (userId, password) =>
      dispatch({
        type: types.USER_AUTHENTICATE,
        userName: userId,
        password: password,
      }),
    setRedirectUrl: currentURL =>
      dispatch({
        type: types.SET_REDIRECT_URL,
        URL: currentURL,
      }),
    logError: error =>
      dispatch({ type: types.APPLICATION_ERROR, error: error }),
    loginError: () => dispatch({ type: types.USER_AUTHENTICATE_FAILURE }),
    clearLogoutMessage: () => {
      dispatch({ type: types.CLEAR_USERLOGGEDOUT_MESSAGE });
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation()(Login));
